import { XStack, YStack } from '@/components/ui/layout/layout';
import { Tooltip } from '@/components/ui/Tooltip';
import { cn } from '@/lib/utils';

export function UsageStatTile({
  value,
  label,
  delta,
  className,
}: {
  value: number;
  label: string;
  delta?: { label: string; tooltip: string } | null;
  className?: string;
}) {
  return (
    <YStack
      className={cn(
        'gap-0.5 rounded-lg border border-border px-3.5 py-3 dark:border-border-strong',
        className
      )}
    >
      <XStack className="items-baseline gap-1.5">
        <span className="text-lg font-semibold tabular-nums text-foreground">
          {value.toLocaleString()}
        </span>
        {delta && (
          <Tooltip label={delta.tooltip}>
            <span className="text-xs tabular-nums text-foreground-muted">
              {delta.label}
            </span>
          </Tooltip>
        )}
      </XStack>
      <span className="text-xs text-foreground-muted">{label}</span>
    </YStack>
  );
}
